import { useQuery } from "@tanstack/react-query";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { getCandidateReview } from "../services/candidate.services";

export const useGetCandidateReview = ({
  jobId,
  candidateId,
}: {
  jobId?: string | number;
  candidateId?: string | number;
}) =>
  useQuery({
    queryKey: GO_HIRE_QUERY_KEYS.candidateReview(jobId!, candidateId!),
    queryFn: () => getCandidateReview({ jobId: jobId!, candidateId: candidateId! }),
    enabled: !!jobId && !!candidateId,
  });
